import {Tag} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

export type AutosaveStatus = 'pristine' | 'saving' | 'saved' | 'error';

interface AutosaveIndicatorProps {
  status: AutosaveStatus;
}

export function AutosaveIndicator(props: AutosaveIndicatorProps) {
  return match(props.status)
    .with('pristine', () => null)
    .with('saving', () => (
      <Tag
        label={i18n.t('page.checklistAudits.form.indicator.saving')}
        colorScheme="blue"
        isSubtle
      />
    ))
    .with('saved', () => (
      <Tag
        label={i18n.t('page.checklistAudits.form.indicator.saved')}
        colorScheme="green"
        isSubtle
      />
    ))
    .with('error', () => (
      <Tag label={i18n.t('page.checklistAudits.form.indicator.error')} colorScheme="red" />
    ))
    .exhaustive();
}
